import { createContext, useContext } from 'react';

export type FileUploadFn = (file: File) => Promise<{ fileName: string }>;
export type GetFileDownloadUrlFn = (fileName: string) => Promise<{ url: string }>;

export type SchemableFormFileUploadContextType = {
  uploadFile: FileUploadFn;
  getFileDownloadUrl: GetFileDownloadUrlFn;
};

export const SchemableFormFileUploadContext = createContext<SchemableFormFileUploadContextType | null>(null);

export const useSchemableFormFileUploadContext = (): SchemableFormFileUploadContextType | null => {
  return useContext(SchemableFormFileUploadContext);
};
